import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import CmmiServices from './components/CmmiServices';
import IsoServices from './components/IsoServices';
import CmmcServices from './components/CmmcServices';
import Soc2Services from './components/Soc2Services';
import TrainingServices from './components/TrainingServices';

function HomePage() {
  return (
    <>
      <Hero />
      <IsoServices />
      <CmmiServices />
      <CmmcServices />
      <Soc2Services />
      <TrainingServices />
      <About />
      <Testimonials />
      <Contact />
    </>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
